/*
 * File: index.tsx
 * Desc: 原图预览组件
 * File Created: 2019-09-12 16:30:22
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { Component } from 'react';
import { ModalCustom } from '..';

type ImgPreviewSourceProps = {
    imgSrc: string;
};
type ImgPreviewSourceState = {
    naturalHeight: string | number;
    naturalWidth: string | number;
};
const imgPreviewInstance = new ModalCustom();

class ImgPreviewSource extends Component<ImgPreviewSourceProps, ImgPreviewSourceState> {
    displayName: string;

    constructor(props: any) {
        super(props);
        this.state = {
            naturalHeight: 'auto',
            naturalWidth: 'auto',
        };
        this.displayName = 'ImgPreviewSource';
    }
    componentWillUnmount() {
        //
    }
    loadImg = (event: React.MouseEvent<HTMLImageElement>) => {
        //
        const { naturalHeight, naturalWidth } = event.currentTarget;
        this.setState({
            naturalHeight,
            naturalWidth,
        });
    };
    close = () => {
        imgPreviewInstance.destroy();
    };
    render() {
        const { naturalWidth, naturalHeight } = this.state;
        const { imgSrc } = this.props;
        return (
            <div className="imgps_root">
                <img
                    src={imgSrc}
                    width={naturalWidth}
                    height={naturalHeight}
                    alt="原图"
                    onLoad={this.loadImg}
                    className="imgps_img_ratio"
                />
                <div className="imgps_close" onClick={this.close}>
                    <i
                        className="imgps_icon"
                        style={{ color: '#ffffff' }}
                    />
                </div>
            </div>
        );
    }
}

/** 原图预览组件 */
export default {
    showImgSource: function(imgSrc: string) {
        imgPreviewInstance.show(<ImgPreviewSource imgSrc={imgSrc} />);
    },
};
